
<router-outlet></router-outlet>
<zi-noty></zi-noty>
